import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  attrs: {
    imageId: {
      key: 'string_value'
    },
    ordinal: {
      key: 'int_value'
    }
  }
});